
import React from 'react';
import { TaxonomyLevel } from '@/types/supabase';
import { reflectionPrompts } from '../constants/reflectionPrompts';

interface ReflectionPromptProps {
  taxonomyLevel: TaxonomyLevel;
}

const ReflectionPrompt: React.FC<ReflectionPromptProps> = ({ taxonomyLevel }) => {
  return (
    <div className="bg-muted p-4 rounded-md">
      <p className="text-sm">{reflectionPrompts[taxonomyLevel]}</p>
    </div>
  );
};

export default ReflectionPrompt;
